import React from 'react';
import { Link } from 'react-router-dom';
import {
  ChartBarIcon,
  Bars3Icon
} from '@heroicons/react/24/outline';

const MobileHeader = ({ darkMode, onMenuToggle }) => {
  return (
    <div className={`
      md:hidden fixed top-0 left-0 right-0 z-20
      ${darkMode ? 'bg-gray-900 border-b border-gray-800' : 'bg-white border-b border-gray-200'}
    `}>
      <div className="flex items-center justify-between px-4 py-3">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <span className={`font-bold text-xl tracking-tight ${
            darkMode ? 'text-gray-100' : 'text-gray-900'
          }`}>
            <span className="text-emerald-500">query</span>
            burst
          </span>
          <ChartBarIcon className="w-5 h-5 text-emerald-500 rotate-45" />
        </Link>

        {/* Hamburger Menu Button */}
        <button
          onClick={onMenuToggle}
          className={`p-2 rounded-md ${
            darkMode ? 'hover:bg-gray-800' : 'hover:bg-gray-100'
          }`}
        >
          <Bars3Icon className="w-6 h-6" />
        </button>
      </div>
    </div>
  );
};

export default MobileHeader; 